// Package tenancy.v3 defines the protocol buffer services for tenancy management
// within the platform. This service provides read-only access to plans and ledger information.

// @generated by protoc-gen-es v2.2.5 with parameter "target=ts"
// @generated from file tenancy/v3/tenancy_service.proto (package tenancy.v3, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv1";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv1";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import { file_common_v3_common } from "../../common/v3/common_pb";
import type { CreditTransaction, LedgerBalance, Plan, TenancyInfo, UsageSummary } from "./tenancy_pb";
import { file_tenancy_v3_tenancy } from "./tenancy_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file tenancy/v3/tenancy_service.proto.
 */
export const file_tenancy_v3_tenancy_service: GenFile = /*@__PURE__*/
  fileDesc("CiB0ZW5hbmN5L3YzL3RlbmFuY3lfc2VydmljZS5wcm90bxIKdGVuYW5jeS52MyJACg5HZXRQbGFuUmVxdWVzdBIuCg9vcmdhbml6YXRpb25faWQYASABKAlCFZq1GBFzdGlkLk9yZ2FuaXphdGlvbiIxCg9HZXRQbGFuUmVzcG9uc2USHgoEcGxhbhgBIAEoCzIQLnRlbmFuY3kudjMuUGxhbiJDChFHZXRCYWxhbmNlUmVxdWVzdBIuCg9vcmdhbml6YXRpb25faWQYASABKAlCFZq1GBFzdGlkLk9yZ2FuaXphdGlvbiJAChJHZXRCYWxhbmNlUmVzcG9uc2USKgoHYmFsYW5jZRgBIAEoCzIZLnRlbmFuY3kudjMuTGVkZ2VyQmFsYW5jZSJHChVHZXRUZW5hbmN5SW5mb1JlcXVlc3QSLgoPb3JnYW5pemF0aW9uX2lkGAEgASgJQhWatRgRc3RpZC5Pcmdhbml6YXRpb24iRwoWR2V0VGVuYW5jeUluZm9SZXNwb25zZRItCgx0ZW5hbmN5X2luZm8YASABKAsyFy50ZW5hbmN5LnYzLlRlbmFuY3lJbmZvIp8BCg9HZXRVc2FnZVJlcXVlc3QSLgoPb3JnYW5pemF0aW9uX2lkGAEgASgJQhWatRgRc3RpZC5Pcmdhbml6YXRpb24SLgoKc3RhcnRfdGltZRgCIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASLAoIZW5kX3RpbWUYAyABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wInIKEEdldFVzYWdlUmVzcG9uc2USMwoMdHJhbnNhY3Rpb25zGAEgAygLMh0udGVuYW5jeS52My5DcmVkaXRUcmFuc2FjdGlvbhIpCgdzdW1tYXJ5GAIgASgLMhgudGVuYW5jeS52My5Vc2FnZVN1bW1hcnkywQIKDlRlbmFuY3lTZXJ2aWNlEkIKB0dldFBsYW4SGi50ZW5hbmN5LnYzLkdldFBsYW5SZXF1ZXN0GhsudGVuYW5jeS52My5HZXRQbGFuUmVzcG9uc2USSwoKR2V0QmFsYW5jZRIdLnRlbmFuY3kudjMuR2V0QmFsYW5jZVJlcXVlc3QaHi50ZW5hbmN5LnYzLkdldEJhbGFuY2VSZXNwb25zZRJXCg5HZXRUZW5hbmN5SW5mbxIhLnRlbmFuY3kudjMuR2V0VGVuYW5jeUluZm9SZXF1ZXN0GiIudGVuYW5jeS52My5HZXRUZW5hbmN5SW5mb1Jlc3BvbnNlEkUKCEdldFVzYWdlEhsudGVuYW5jeS52My5HZXRVc2FnZVJlcXVlc3QaHC50ZW5hbmN5LnYzLkdldFVzYWdlUmVzcG9uc2VCXVpbZ2l0aHViLmNvbS9TdG9yeXRlbGwtYWkvc3Rvcnl0ZWxsLWFpLXBsYXRmb3JtL3BrZy9nby9kb21haW5zL2NwL2dlbi9wYi90ZW5hbmN5L3YzO3RlbmFuY3lWM2IGcHJvdG8z", [file_google_protobuf_timestamp, file_common_v3_common, file_tenancy_v3_tenancy]);

/**
 * GetPlanRequest for retrieving plan information
 *
 * @generated from message tenancy.v3.GetPlanRequest
 */
export type GetPlanRequest = Message<"tenancy.v3.GetPlanRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message tenancy.v3.GetPlanRequest.
 * Use `create(GetPlanRequestSchema)` to create a new message.
 */
export const GetPlanRequestSchema: GenMessage<GetPlanRequest> = /*@__PURE__*/
  messageDesc(file_tenancy_v3_tenancy_service, 0);

/**
 * GetPlanResponse contains the plan information
 *
 * @generated from message tenancy.v3.GetPlanResponse
 */
export type GetPlanResponse = Message<"tenancy.v3.GetPlanResponse"> & {
  /**
   * @generated from field: tenancy.v3.Plan plan = 1;
   */
  plan: Plan;
};

/**
 * Describes the message tenancy.v3.GetPlanResponse.
 * Use `create(GetPlanResponseSchema)` to create a new message.
 */
export const GetPlanResponseSchema: GenMessage<GetPlanResponse> = /*@__PURE__*/
  messageDesc(file_tenancy_v3_tenancy_service, 1);

/**
 * GetBalanceRequest for retrieving ledger balance
 *
 * @generated from message tenancy.v3.GetBalanceRequest
 */
export type GetBalanceRequest = Message<"tenancy.v3.GetBalanceRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message tenancy.v3.GetBalanceRequest.
 * Use `create(GetBalanceRequestSchema)` to create a new message.
 */
export const GetBalanceRequestSchema: GenMessage<GetBalanceRequest> = /*@__PURE__*/
  messageDesc(file_tenancy_v3_tenancy_service, 2);

/**
 * GetBalanceResponse contains the ledger balance
 *
 * @generated from message tenancy.v3.GetBalanceResponse
 */
export type GetBalanceResponse = Message<"tenancy.v3.GetBalanceResponse"> & {
  /**
   * @generated from field: tenancy.v3.LedgerBalance balance = 1;
   */
  balance: LedgerBalance;
};

/**
 * Describes the message tenancy.v3.GetBalanceResponse.
 * Use `create(GetBalanceResponseSchema)` to create a new message.
 */
export const GetBalanceResponseSchema: GenMessage<GetBalanceResponse> = /*@__PURE__*/
  messageDesc(file_tenancy_v3_tenancy_service, 3);

/**
 * GetTenancyInfoRequest for retrieving comprehensive tenancy information
 *
 * @generated from message tenancy.v3.GetTenancyInfoRequest
 */
export type GetTenancyInfoRequest = Message<"tenancy.v3.GetTenancyInfoRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message tenancy.v3.GetTenancyInfoRequest.
 * Use `create(GetTenancyInfoRequestSchema)` to create a new message.
 */
export const GetTenancyInfoRequestSchema: GenMessage<GetTenancyInfoRequest> = /*@__PURE__*/
  messageDesc(file_tenancy_v3_tenancy_service, 4);

/**
 * GetTenancyInfoResponse contains comprehensive tenancy information
 *
 * @generated from message tenancy.v3.GetTenancyInfoResponse
 */
export type GetTenancyInfoResponse = Message<"tenancy.v3.GetTenancyInfoResponse"> & {
  /**
   * @generated from field: tenancy.v3.TenancyInfo tenancy_info = 1;
   */
  tenancyInfo: TenancyInfo;
};

/**
 * Describes the message tenancy.v3.GetTenancyInfoResponse.
 * Use `create(GetTenancyInfoResponseSchema)` to create a new message.
 */
export const GetTenancyInfoResponseSchema: GenMessage<GetTenancyInfoResponse> = /*@__PURE__*/
  messageDesc(file_tenancy_v3_tenancy_service, 5);

/**
 * GetUsageRequest for retrieving usage information
 *
 * @generated from message tenancy.v3.GetUsageRequest
 */
export type GetUsageRequest = Message<"tenancy.v3.GetUsageRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: google.protobuf.Timestamp start_time = 2;
   */
  startTime: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp end_time = 3;
   */
  endTime: Timestamp;
};

/**
 * Describes the message tenancy.v3.GetUsageRequest.
 * Use `create(GetUsageRequestSchema)` to create a new message.
 */
export const GetUsageRequestSchema: GenMessage<GetUsageRequest> = /*@__PURE__*/
  messageDesc(file_tenancy_v3_tenancy_service, 6);

/**
 * GetUsageResponse contains usage transactions and summary
 *
 * @generated from message tenancy.v3.GetUsageResponse
 */
export type GetUsageResponse = Message<"tenancy.v3.GetUsageResponse"> & {
  /**
   * @generated from field: repeated tenancy.v3.CreditTransaction transactions = 1;
   */
  transactions: CreditTransaction[];

  /**
   * @generated from field: tenancy.v3.UsageSummary summary = 2;
   */
  summary: UsageSummary;
};

/**
 * Describes the message tenancy.v3.GetUsageResponse.
 * Use `create(GetUsageResponseSchema)` to create a new message.
 */
export const GetUsageResponseSchema: GenMessage<GetUsageResponse> = /*@__PURE__*/
  messageDesc(file_tenancy_v3_tenancy_service, 7);

/**
 * TenancyService provides read-only access to plans and ledger information
 *
 * @generated from service tenancy.v3.TenancyService
 */
export const TenancyService: GenService<{
  /**
   * Get plan information for an organization
   *
   * @generated from rpc tenancy.v3.TenancyService.GetPlan
   */
  getPlan: {
    methodKind: "unary";
    input: typeof GetPlanRequestSchema;
    output: typeof GetPlanResponseSchema;
  },
  /**
   * Get current ledger balance for an organization
   *
   * @generated from rpc tenancy.v3.TenancyService.GetBalance
   */
  getBalance: {
    methodKind: "unary";
    input: typeof GetBalanceRequestSchema;
    output: typeof GetBalanceResponseSchema;
  },
  /**
   * Get comprehensive tenancy information (plan + balance + usage)
   *
   * @generated from rpc tenancy.v3.TenancyService.GetTenancyInfo
   */
  getTenancyInfo: {
    methodKind: "unary";
    input: typeof GetTenancyInfoRequestSchema;
    output: typeof GetTenancyInfoResponseSchema;
  },
  /**
   * Get detailed usage for an organization
   *
   * @generated from rpc tenancy.v3.TenancyService.GetUsage
   */
  getUsage: {
    methodKind: "unary";
    input: typeof GetUsageRequestSchema;
    output: typeof GetUsageResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_tenancy_v3_tenancy_service, 0);

